export default __webpack_public_path__ + "static/media/discover.1d5069f7.svg";